import {
  ChangeDetectionStrategy,
  Component,
  Input,
  NgModule,
  TemplateRef,
  ViewEncapsulation,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { RouterStaticLinkDirectiveModule } from '@icilalune/utils';

export interface ServiceMenuItem {
  label?: string;
  id: string;
  path?: string;
  linkedNodeId?: string;
  iconId?: string;
  className?: string;
}

@Component({
  selector: 'i2l-ui-services-menu',
  template: `
    <h3 class="title">
      <a [innerHTML]="title" [routerStaticLink]="titlePath"></a>
    </h3>
    <ng-container *ngIf="items">
      <ul>
        <ng-template ngFor [ngForOf]="items" let-item [ngForTrackBy]="identity">
          <li>
            <ng-template
              [ngTemplateOutlet]="itemTemplate"
              [ngTemplateOutletContext]="{ $implicit: item }"
            >
            </ng-template>
          </li>
        </ng-template>
      </ul>
    </ng-container>
  `,
  styleUrls: ['./services-menu.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ServicesMenuComponent {
  @Input()
  title!: string | undefined;

  @Input()
  items!: ServiceMenuItem[];

  @Input()
  itemTemplate!: TemplateRef<ServiceMenuItem>;

  @Input()
  titlePath: string | undefined;

  identity(index: number, item: ServiceMenuItem) {
    return item.id;
  }
}

@NgModule({
  imports: [CommonModule, RouterModule, RouterStaticLinkDirectiveModule],
  declarations: [ServicesMenuComponent],
  exports: [ServicesMenuComponent],
})
export class ServicesMenuComponentModule {}
